import React from "react";
import PropTypes from "prop-types";

const NotificationItem = ({ notification, ...props }) => (
  <li {...props}>
    {notification.createdAt}
    {notification.htmlContent ? (
      <div
        className="content"
        dangerouslySetInnerHTML={{ __html: notification.htmlContent }}
      ></div>
    ) : (
      <div className="content">{`${notification.title} ${notification.content}`}</div>
    )}
  </li>
);

NotificationItem.propTypes = {
  notification: PropTypes.shape({
    createdAt: PropTypes.any,
    content: PropTypes.string,
    title: PropTypes.string,
    htmlContent: PropTypes.string
  }).isRequired
};

export default NotificationItem;
